import request from '@/utils/request'


// 查询科室列表
export function listDepartments(query) {
  return request({
    url: '/biz/departments/list',
    method: 'get',
    params: query
  })
}

// 查询科室分页
export function pageDepartments(query) {
  return request({
    url: '/biz/departments/page',
    method: 'get',
    params: query
  })
}

// 查询科室详细
export function getDepartments(data) {
  return request({
    url: '/biz/departments/detail',
    method: 'get',
    params: data
  })
}

// 新增科室
export function addDepartments(data) {
  return request({
    url: '/biz/departments/add',
    method: 'post',
    data: data
  })
}

// 修改科室
export function updateDepartments(data) {
  return request({
    url: '/biz/departments/edit',
    method: 'post',
    data: data
  })
}

// 删除科室
export function delDepartments(data) {
  return request({
    url: '/biz/departments/delete',
    method: 'post',
    data: data
  })
}
